export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};


export const messages = {
    "login.form.title": "Kirjaudu sisään",
    "login.form.hint.user": "Sisäänkirjaus",
    "login.form.hint.password": "Salasana",
    "login.form.checkbox.remember-me": "Muista minut",
    "login.form.button.sign-in": "Kirjaudu sisään",
    "login.form.message.invalid-user-credentials": "Kirjautumistunnus tai salasana on väärä",
    "login.form.message.user-required": "Anna kirjautumistunnus",
    "login.form.message.password-required": "Anna salasana",
    "login.form.button.forgot-password": "Unohditko salasanasi?",
    "error.root-admin-login.title": "Virhe 403 – kielletty",
    "error.root-admin-login.message": "Olet kirjautunut vain luku -pääkäyttäjänä. Jos haluat käyttää Web Recovery -konsolia, kirjaudu asiakkaan haltijakäyttäjänä tai pääkäyttäjänä"
};
